"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
const react_1 = __importDefault(require("react"));
const lodash_1 = __importDefault(require("lodash"));
const prop_types_1 = require("prop-types");
const utilities_1 = require("../../utilities");
const styles_module_css_1 = __importDefault(require("./styles.module.css"));
function EducationTooltip(_ref) {
  let {
    values,
    category,
    color,
    parentValues
  } = _ref;
  return react_1.default.createElement("div", {
    style: {
      width: '90%',
      maxWidth: 500
    }
  }, values.map(_ref2 => {
    let {
      value,
      name,
      unit
    } = _ref2;
    const {
      value: parentValue = 1
    } = lodash_1.default.find(parentValues, _ref3 => {
      let {
        name: parentName
      } = _ref3;
      return parentName === name;
    }) || {};
    const selected = name === category;
    return react_1.default.createElement("div", {
      className: `${styles_module_css_1.default['tooltip-entry']} ${selected ? styles_module_css_1.default.selected : ''}`,
      key: name
    }, react_1.default.createElement("div", {
      style: {
        lineHeight: '1.1em'
      }
    }, react_1.default.createElement("span", {
      className: styles_module_css_1.default.value,
      style: selected ? {
        color
      } : {}
    }, (0, utilities_1.valueFormat)({
      params: {
        format: 'percent'
      }
    })(value / parentValue)), react_1.default.createElement("span", null, unit ? ` ${unit}` : '')), react_1.default.createElement("div", {
      className: styles_module_css_1.default['tooltip-back']
    }, react_1.default.createElement("div", {
      className: styles_module_css_1.default['tooltip-percent'],
      style: {
        background: selected ? color : null,
        width: `${value / parentValue * 100}%`
      }
    })));
  }));
}
EducationTooltip.propTypes = {
  values: (0, prop_types_1.arrayOf)((0, prop_types_1.shape)({
    value: prop_types_1.number.isRequired,
    name: prop_types_1.string.isRequired,
    unit: prop_types_1.string
  })).isRequired,
  category: prop_types_1.string.isRequired,
  color: prop_types_1.string.isRequired,
  parentValues: (0, prop_types_1.arrayOf)((0, prop_types_1.shape)({
    name: prop_types_1.string,
    value: prop_types_1.number
  }))
};
exports.default = EducationTooltip;